(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('SesameAccessController', sesameAccess);

  sesameAccess.$inject = ['$scope', '$location', '$stateParams', 'LangService', 'AuthenticationService', 'UserService', 'SesameAuthService', '$http', 'LoginService', '$rootScope', 'LocalStorageService'];

  function sesameAccess ($scope, $location, $stateParams, LangService, AuthenticationService, UserService, SesameAuthService, $http, LoginService, $rootScope, LocalStorageService) {
    var vm = this;

    if (localStorage.getItem('language')) {
      vm.language = localStorage.getItem('language');
    } else {
      vm.language = 'pt';
      localStorage.setItem('language', 'pt');
    }

    	$scope.vm = vm;

    if ($rootScope.changepassword) {
      $scope.vm.changepassword = 1;
    }

    AuthenticationService.ClearCredentials();
    vm.username = vm.password = '';
    vm.hash = $stateParams.hash;
    vm.path = null;
    vm.invalidLink = false;
    vm.error = '';
    vm.companyId = null;
    vm.sesameValidatedAccess = false;

    vm.changeLanguage = function () {
      LangService
        .getSesameFirstAccessLabels({ 'locale': vm.language })
        .$promise
        .then(function (data) {
          vm.labels = data.lang;
        });
    }
    vm.changeLanguage();

    vm.validateAccessHash = function () {
      SesameAuthService
        .validateHash({ 'hash': vm.hash })
        .$promise
        .then(function (data) {
          if (!data.success) {
            vm.error = data.message;
            vm.invalidLink = true;
          }
          vm.companyId = data.company_id;
        });
    }
    vm.validateAccessHash();

    vm.sesameFirstLogin = function () {
      SesameAuthService
        .sesameFirstLogin({ hash: vm.hash, email: vm.username, password: vm.password, company_id: vm.companyId })
        .$promise
        .then(function (data) {
          if (!data.success) {
            vm.error = data.message;
            vm.invalidLink = true;
          } else {
            vm.sesameValidatedAccess = true;
          }
        }).catch(function (error) {
          vm.error = error.data.message;
        });
    }

    vm.successLogin = function (username, response) {
      $scope.success = true;
      AuthenticationService.SetCredentials(username, response.token);
      if (response.change_warning) {
        alert(response.change_warning);
      }
      if (response.reset_password) {
        vm.resetpassword = true;
        alert(vm.labels.expiredPassword);
      }

      if (response.change == 1) {
        vm.changepassword = true;
      } else {
        LocalStorageService.clearUserPauseState();
        $location.path(frontUrl + '/chat');
      }
    };

    vm.errorLogin = function (response) {
      var message = vm.labels.invalidEmailPassword;
      if (response.message) {
        message = response.message
      }
      vm.error = message;
    };

    vm.logIn = function () {
      AuthenticationService.Login(vm.username, vm.password, function (response) {
        if (response.success) {
          vm.successLogin(vm.username, response)
        } else {
          vm.errorLogin(response);
        }
      }, function (data) {
        if (!$scope.success) {
          vm.error = data.message;
        }
      });
    }
  }
})();
